import axios from "axios";

export type PublicTrackingStatus =
  | "RECEIVED"
  | "SCHEDULED"
  | "PICKUP_IN_PROGRESS"
  | "IN_TRANSIT"
  | "DELIVERED"
  | "CANCELLED";
export interface PublicTrackingAddress {
  addressLine?: string | null;
  postCode?: string | null;
  city?: string | null;
  countryCode?: string | null;
}
export interface PublicOrderTrackingStop {
  stopNumber?: number | null;
  type: "PICKUP" | "DELIVERY" | "STOP";
  address?: PublicTrackingAddress | null;
  plannedDate?: string | null;
  completedAt?: string | null;
  status: "PENDING" | "IN_PROGRESS" | "COMPLETED" | "CANCELLED";
}
export interface PublicOrderTracking {
  stops?: PublicOrderTrackingStop[] | null;
  orderNumber?: string | null;
  carrierName?: string | null;
  carrierLogoUrl?: string | null;
  status: PublicTrackingStatus;
  pickup?: { plannedDate?: string | null; completedAt?: string | null } | null;
  delivery?: {
    plannedDate?: string | null;
    completedAt?: string | null;
  } | null;
  deliveryAddress?: PublicTrackingAddress | null;
  recipient?: {
    name?: string | null;
    address?: PublicTrackingAddress | null;
    email?: string | null;
    phoneNumber?: string | null;
  } | null;
  lastUpdated?: string | null;
}

export async function getPublicTracking(
  token: string,
): Promise<PublicOrderTracking> {
  const response = await axios.get(
    `${process.env.REACT_APP_CLOUD_API_URL}/api/public/tracking/`,
    { headers: { "X-Tracking-Token": token } },
  );
  return response.data.data;
}
